module.exports = __webpack_public_path__ + "img/event-grand-bal-janvier-2025.57f84e6.jpg";